module.exports = __webpack_public_path__ + "img/4-2.fa023301.svg";